import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const applicationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadApplication: builder.query({
      query: (id) => (config.GetApplication || "") + id,
    }),
    loadAppSummary: builder.query({
      query: (id) => (config.GetApplicationSummary || "") + id,
      providesTags: (result, error, id) => [{ type: "ApplicationSummary", id }],
    }),
    loadAppUpdates: builder.query({
      query: (id) => (config.GetAppUpdateDataHistory || "") + id,
      providesTags: (result, error, id) => [{ type: "AppUpdates", id }],
    }),
    loadAppDefaultData: builder.query({
      query: (id) => (config.GetWorkfinityAppEntity || "") + id,
    }),
    startNewApplication: builder.mutation({
      query: (data) => ({
        url: config.StartNewApplication || "",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoadApplicationQuery,
  useLazyLoadApplicationQuery,
  useLoadAppSummaryQuery,
  useLazyLoadAppSummaryQuery,
  useLoadAppUpdatesQuery,
  useLazyLoadAppUpdatesQuery,
  useLoadAppDefaultDataQuery,
  useLazyLoadAppDefaultDataQuery,
  useStartNewApplicationMutation,
} = applicationApiSlice;
